export default "__VITE_ASSET__b985cbb7__"